import GoogleMapWrapper from 'components/GoogleMapWrapper'
import {
  GoogleMapTileLayer,
  ProtomapsTileLayer,
} from 'components/MapLibreTileLayer/MapLibreTileLayer'
import { useState } from 'react'
import { MapContainer, MapContainerProps } from 'react-leaflet'
import { log } from '@astronautsid/wpe-utils'

export type PoolMapType = {
  children: React.ReactNode
  mqttUsername?: string
  mqttPassword?: string
} & MapContainerProps

const PoolMap = ({
  children,
  zoom = 19,
  maxZoom = 22,
  minZoom = 8,
  dragging = true,
  ...props
}: PoolMapType) => {
  const [useDynamicJSAPI, setUseDynamicJSAPI] = useState(false)

  const handleRateLimitError = (errorMessage: string) => {
    if (process.env.REACT_APP_DATADOG_LOG_FALLBACK_MAPS === 'true') {
      log.error(errorMessage, {
        customInfo: {
          origin: 'maps',
        },
      })
    }

    setUseDynamicJSAPI(true)
  }

  return (
    <GoogleMapWrapper useDynamicJSAPI={useDynamicJSAPI}>
      <MapContainer
        zoom={zoom}
        maxZoom={maxZoom}
        minZoom={minZoom}
        dragging={dragging}
        style={{ width: '100%', height: '100vh' }}
        {...props}
      >
        {useDynamicJSAPI ? (
          <GoogleMapTileLayer />
        ) : (
          <ProtomapsTileLayer
            url="/map-styles.json"
            attribution='<a href="https://openfreemap.org" target="_blank">OpenFreeMap</a> <a href="https://www.openmaptiles.org/" target="_blank">© OpenMapTiles</a> Data from <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
            onRateLimitError={handleRateLimitError}
          />
        )}
        {children}
      </MapContainer>
    </GoogleMapWrapper>
  )
}

export default PoolMap
